import { render, staticRenderFns } from "./EstimateCorpCard.vue?vue&type=template&id=553f5ae3&"
import script from "./EstimateCorpCard.vue?vue&type=script&lang=js&"
export * from "./EstimateCorpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports